import type { LegalCopy } from '../types'

export const hi: LegalCopy = {
  title: 'कानूनी मदद',
  subtitle: 'आम कानूनी परेशानियाँ, आसान शब्दों में। अपनी भाषा में सुनें, और हर जवाब का सरकारी स्रोत देखें।',
  helplinesTitle: 'हेल्पलाइन (मुफ़्त कॉल)',
  helplines: {
    emergency: 'इमरजेंसी: पुलिस, फ़ायर, एम्बुलेंस',
    legal_aid: 'मुफ़्त कानूनी मदद (NALSA)',
    cyber: 'ऑनलाइन / UPI धोखाधड़ी',
    women: 'महिला हेल्पलाइन',
    consumer: 'उपभोक्ता हेल्पलाइन'
  },
  faqTitle: 'आम सवाल',
  searchPlaceholder: 'खोजें: FIR, धोखाधड़ी, RTI, वकील…',
  noMatch: 'कोई सवाल नहीं मिला। नीचे अपना सवाल पूछें।',
  sources: 'सरकारी स्रोत',
  listen: 'सुनाओ',
  askTitle: 'अपना कानूनी सवाल पूछें',
  askHint: 'समझो सिर्फ़ सरकारी वेबसाइटों से जवाब देता है, स्रोत के लिंक के साथ।',
  starters: ['क्या मुझे मुफ़्त वकील मिल सकता है?', 'किसी ने मेरे साथ ऑनलाइन धोखा किया। मैं क्या करूँ?', 'पुलिस मेरी शिकायत नहीं लिख रही। मैं क्या कर सकता हूँ?'],
  disclaimer:
    'यह सरकारी स्रोतों से ली गई आम जानकारी है, आपके केस के लिए कानूनी सलाह नहीं। अपने केस के लिए वकील से बात करें — विधिक सेवा प्राधिकरण (15100) से मुफ़्त वकील मिल सकता है।',
  topics: {
    get_free_aid: {
      q: 'मुफ़्त कानूनी मदद कैसे मिलेगी?',
      a: 'NALSA की मुफ़्त हेल्पलाइन 15100 पर कॉल करें। या अपने ज़िला न्यायालय में विधिक सेवा प्राधिकरण के दफ़्तर, या तालुका न्यायालय में विधिक सेवा समिति जाएँ। आप ऑनलाइन, डाक से या ई-मेल से भी आवेदन कर सकते हैं। फ़ॉर्म मुफ़्त है, और वकील की फ़ीस और कोर्ट का खर्च आपके लिए भरा जाता है।'
    },
    who_free_aid: {
      q: 'मुफ़्त वकील किसे मिल सकता है?',
      a: 'कानून (विधिक सेवा प्राधिकरण अधिनियम की धारा 12) इन्हें मुफ़्त कानूनी मदद देता है: महिलाएँ और बच्चे, SC/ST के लोग, दिव्यांग, औद्योगिक मज़दूर, मानव तस्करी या बेगार के शिकार, आपदा, जातिगत अत्याचार या जातीय हिंसा के शिकार, हिरासत में रखे लोग, और वे लोग जिनकी सालाना आमदनी उनके राज्य की तय सीमा से कम है। आमदनी की सीमा हर राज्य में अलग है।'
    },
    fir: {
      q: 'पुलिस मेरी FIR नहीं लिख रही। मैं क्या करूँ?',
      a: 'गंभीर (संज्ञेय) अपराध की रिपोर्ट आप किसी भी थाने में कर सकते हैं, चाहे अपराध कहीं और हुआ हो — इसे ज़ीरो FIR कहते हैं। पुलिस को आपको FIR की कॉपी मुफ़्त देनी होती है। अगर पुलिस मना करे, तो अपनी शिकायत लिखकर डाक से पुलिस अधीक्षक (SP) को भेजें। अगर SP भी कुछ न करें, तो आप शपथ-पत्र के साथ मजिस्ट्रेट के पास आवेदन कर सकते हैं।'
    },
    cyber_fraud: {
      q: 'ऑनलाइन या UPI धोखाधड़ी में मेरे पैसे चले गए। क्या करूँ?',
      a: 'तुरंत 1930 पर कॉल करें — यह राष्ट्रीय साइबर क्राइम हेल्पलाइन है, मुफ़्त है और दिन-रात चलती है। जल्दी बताने से पैसा आगे भेजे जाने से रोका जा सकता है। साथ ही cybercrime.gov.in पर “Financial Fraud” में शिकायत दर्ज करें।'
    },
    women: {
      q: 'कोई महिला हिंसा या उत्पीड़न झेल रही है। उसे मदद कहाँ मिलेगी?',
      a: 'इमरजेंसी में पुलिस, फ़ायर या एम्बुलेंस के लिए 112 मिलाएँ। मुफ़्त महिला हेल्पलाइन 181 पर दिन-रात कभी भी कॉल करें। आप अपना नाम छिपा सकती हैं, और यह आपको पुलिस, वन स्टॉप सेंटर, अस्पताल या कानूनी मदद से जोड़ती है। राष्ट्रीय महिला आयोग की हेल्पलाइन 14490 भी है, और वह ऑनलाइन शिकायत भी लेता है।'
    },
    consumer: {
      q: 'दुकान या कंपनी ने मुझे ठगा। शिकायत कहाँ करूँ?',
      a: 'राष्ट्रीय उपभोक्ता हेल्पलाइन 1915 पर कॉल करें (मुफ़्त, सुबह 8 से रात 8 बजे), 8800001915 पर WhatsApp करें, या consumerhelpline.gov.in पर शिकायत करें। उपभोक्ता आयोग में केस करना हो, तो e-Daakhil पर ऑनलाइन कर सकते हैं।'
    },
    summons: {
      q: 'मुझे कोर्ट का समन मिला है। क्या करूँ?',
      a: 'समन में लिखा होता है कि आपको किस तारीख़ को कोर्ट आना है। अगर आप योग्य हैं, तो केस के किसी भी चरण में मुफ़्त वकील मिल सकता है: 15100 पर कॉल करें या अपने ज़िला न्यायालय में विधिक सेवा के दफ़्तर जाएँ। अपने केस और अगली तारीख़ की जानकारी eCourts वेबसाइट या ऐप पर देख सकते हैं।'
    },
    case_status: {
      q: 'अपने कोर्ट केस का स्टेटस कैसे देखूँ?',
      a: 'services.ecourts.gov.in पर जाएँ, या eCourts Services ऐप खोलें, और अपने 16 अंकों के CNR नंबर या केस की दूसरी जानकारी से खोजें। SMS भी कर सकते हैं: ECOURTS, फिर एक स्पेस, फिर अपना CNR नंबर लिखकर 9766899899 पर भेजें।'
    },
    lok_adalat: {
      q: 'लोक अदालत क्या है?',
      a: 'लोक अदालत दोनों पक्षों की सहमति से केस निपटाती है। इसमें कोई कोर्ट फ़ीस नहीं लगती, और अगर कोर्ट में चल रहा केस यहाँ निपट जाए, तो भरी हुई कोर्ट फ़ीस वापस मिल जाती है। इसका फ़ैसला कोर्ट की डिक्री जैसा अंतिम और सब पर लागू होता है, और इसके ख़िलाफ़ अपील नहीं होती।'
    },
    rti: {
      q: 'RTI कैसे लगाऊँ?',
      a: 'केंद्र सरकार के दफ़्तरों के लिए rtionline.gov.in पर ऑनलाइन आवेदन करें। फ़ीस ₹10 है; गरीबी रेखा से नीचे (BPL) हैं तो कोई फ़ीस नहीं (BPL प्रमाणपत्र लगाएँ)। अधिकारी को 30 दिन में जवाब देना होता है, और किसी की जान या आज़ादी का मामला हो तो 48 घंटे में। 30 दिन में जवाब न मिले, तो अगले 30 दिन में मुफ़्त पहली अपील कर सकते हैं।'
    },
    grievance: {
      q: 'सरकारी दफ़्तर मेरा काम नहीं कर रहा। शिकायत कहाँ करूँ?',
      a: 'pgportal.gov.in पर CPGRAMS में शिकायत दर्ज करें — यह दिन-रात खुला है (इसका ऐप और UMANG भी है)। 21 दिन में हल करने का लक्ष्य रखा गया है। इसमें RTI के मामले, कोर्ट केस, धार्मिक मामले या सरकारी कर्मचारियों के सेवा मामले नहीं लिए जाते।'
    }
  }
}
